module.exports = __webpack_public_path__ + "img/logo-white.f1cd4fa1.svg";